import { useEffect, useState } from "react";
import { supabase } from "../lib/supabaseClient";
import { Button } from "./ui/button";
import { ArrowLeft } from "lucide-react";

export function MasterViewExitBar() {
  const [role, setRole] = useState(() => sessionStorage.getItem("sr_master_view_role") || "");

  useEffect(() => {
    const sync = () => setRole(sessionStorage.getItem("sr_master_view_role") || "");
    window.addEventListener("storage", sync);
    window.addEventListener("focus", sync);
    return () => {
      window.removeEventListener("storage", sync);
      window.removeEventListener("focus", sync);
    };
  }, []);

  if (!role) return null;

  const exit = async () => {
    const saved = sessionStorage.getItem("sr_admin_session");
    sessionStorage.removeItem("sr_master_view_role");
    sessionStorage.removeItem("sr_admin_session");
    try {
      if (saved) {
        const { access_token, refresh_token } = JSON.parse(saved);
        await supabase.auth.setSession({ access_token, refresh_token });
      } else {
        await supabase.auth.signOut();
      }
    } catch (e) {
      await supabase.auth.signOut();
    }
    window.location.href = "/admin";
  };

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[999] flex flex-wrap items-center justify-center gap-3 border-t border-amber-300 bg-amber-100 px-4 py-2 text-sm text-amber-900 shadow-[0_-2px_8px_rgba(0,0,0,0.08)]"
      data-testid="master-view-exit-bar"
    >
      <span className="font-semibold">Master View (Admin)</span>
      <span>You're viewing SimplyRefer as the dedicated {role} QA test account. Nothing here is a real user.</span>
      <Button size="sm" variant="outline" className="border-amber-400 bg-white" onClick={exit} data-testid="master-view-exit-bar-button">
        <ArrowLeft className="mr-1.5 h-3.5 w-3.5" /> Exit Master View
      </Button>
    </div>
  );
}
